/*
    Bootstrap option to redirect to another URL
    This is enabled via env variables

     VITE_CANARY_RELEASE_ENABLE: str                    # enabled if 'true'
     VITE_CANARY_RELEASE_A_URL: str                     # URL of the A mode or string "none" if nothing should be done
     VITE_CANARY_RELEASE_B_URL: str                     # URL of the B mode or string "none" if nothing should be done
     VITE_CANARY_RELEASE_STICKY: A|B|AB|none = none     # Which scenario is "sticky" where "sticky" means that if a user sees
                                                        # a scenario it will always see that scenario otherwise if the "prc" change,
                                                        # the scenario will be recomputed.
     VITE_CANARY_RELEASE_PARAM_NAME: str = canary       # Name of the query parameter used to enable the canary release mechanism
                                                        # and set the percentage value
     VITE_CANARY_RELEASE_DEFAULT_PRC: int               # 0-100, Default percentage that goes through B, if query parameter
                                                        # `VITE_CANARY_RELEASE_PARAM_NAME` is not set
     VITE_CANARY_RELEASE_STORGE: cookie|local = local   # `local` will first try using local storage and fall back on cookie if
                                                        # available
     VITE_CANARY_RELEASE_COOKIE_EXP_DAYS: int = 150     # Expiration days of the cookie
 */
const STORAGE_KEY = "canaryData";
const COOKIE_EXPIRATION_DAYS = Number(import.meta.env.VITE_CANARY_RELEASE_COOKIE_EXP_DAYS || 150);

function getCookie(name) {
  const cookieSplit = document.cookie
    .split(";")
    .find((row) => row.trimStart().startsWith(name + "="))
    ?.trimStart()
    .split("=");

  if (cookieSplit && cookieSplit.length > 1) {
    return decodeURIComponent(cookieSplit[1]);
  }
}

function setCookie(name, value, expireDays) {
  const d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

function getCanaryData() {
  if ((import.meta.env.VITE_CANARY_RELEASE_STORGE || "local") === "local" && "localStorage" in window) {
    const redirectionData = window.localStorage.getItem(STORAGE_KEY);
    if (redirectionData) {
      return JSON.parse(redirectionData);
    }
    return;
  }

  const redirectionData = getCookie(STORAGE_KEY);
  if (redirectionData) {
    return JSON.parse(redirectionData);
  }
}

function setCanaryData(data) {
  const dataStr = JSON.stringify(data);
  if ((import.meta.env.VITE_CANARY_RELEASE_STORGE || "local") === "local" && "localStorage" in window) {
    window.localStorage.setItem(STORAGE_KEY, dataStr);
    return;
  }

  setCookie(STORAGE_KEY, dataStr, COOKIE_EXPIRATION_DAYS);
}

// Global code in a module is run only one time
if (import.meta.env.VITE_CANARY_RELEASE_ENABLE === "true") {
  const paramName = import.meta.env.VITE_CANARY_RELEASE_PARAM_NAME || "canary";
  const stickyness = import.meta.env.VITE_CANARY_RELEASE_STICKY || "none";
  const stickyA = ["A", "AB"].includes(stickyness);
  const stickyB = ["B", "AB"].includes(stickyness);

  let computeScenario = true;

  const url = new URL(window.location.href);

  if (url.searchParams.has(paramName)) {
    const canaryPrc = Number(url.searchParams.get(paramName) || import.meta.env.VITE_CANARY_RELEASE_DEFAULT_PRC);
    if (isNaN(canaryPrc)) {
      console.error("Error while getting the canary percentage, value is NaN. Canary feature will do nothing.");
    } else {
      let redirectionData = getCanaryData();
      if (redirectionData) {
        const prcChanged = canaryPrc !== redirectionData.prc;
        const scenario = redirectionData.scenario;
        computeScenario = prcChanged && ((!stickyA && scenario === "A") || (!stickyB && scenario === "B"));
      }
      if (computeScenario) {
        const scenario = Math.random() * 100 <= canaryPrc ? "B" : "A";
        redirectionData = { scenario: scenario, prc: canaryPrc };
        setCanaryData(redirectionData);
      }
      const redirectionUrl = redirectionData.scenario === "A" ? import.meta.env.VITE_CANARY_RELEASE_A_URL : import.meta.env.VITE_CANARY_RELEASE_B_URL;
      if (redirectionUrl && redirectionUrl !== "none") {
        const queryParams = url.searchParams;
        queryParams.delete(paramName);
        window.location.href = redirectionUrl + (redirectionUrl.includes("?") ? "&" : "?") + queryParams.toString();
      }
    }
  }
}
